import { defineStore } from 'pinia'
import { computed, type ComputedRef } from 'vue'
import { ExperienceFlowEnum } from '@gh/common/models'
import { useBrandingStore } from './branding'
import type { ExperienceFlowStoreType } from '@/services/experienceFlows/types'
import { useExperienceFlowDefaultStore } from './experienceFlows/default'
import { useExperienceFlowAstrazenecaStore } from './experienceFlows/astrazeneca'

type AdditionalParams = {
  ExperienceFlow: ComputedRef<ExperienceFlowEnum | undefined>
  storeId: ComputedRef<string>
}

export const useExperienceFlowStore = defineStore<
  'experienceFlow',
  ExperienceFlowStoreType & AdditionalParams
>('experienceFlow', () => {
  const brandingStore = useBrandingStore()
  const experienceFlow = computed(() => brandingStore.branding?.experienceFlow)

  const store = computed(() => {
    switch (experienceFlow.value) {
      case ExperienceFlowEnum.Astrazeneca:
        return useExperienceFlowAstrazenecaStore()
      case ExperienceFlowEnum.Default:
      default:
        return useExperienceFlowDefaultStore()
    }
  })

  return {
    ExperienceFlow: experienceFlow,
    storeId: computed(() => store.value.$id),
    empty: computed(() => store.value.empty),
    sponsorScreenAfterClassSelection: computed(() => store.value.sponsorScreenAfterClassSelection),
  }
})
